import { Theme } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import TextField, { BaseTextFieldProps, TextFieldProps } from '@mui/material/TextField';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import { CalendarEventVisibility } from '../../../sic-lib/enums/CalendarEventVisibility';
import { useAppDispatch } from '../../../store/hooks';

const useStyles = makeStyles()((theme: Theme) => ({
    root: {
        minWidth: '200px',
    },
}));

type Props = BaseTextFieldProps & {
    onSelectHandler: React.Dispatch<{ visibility: CalendarEventVisibility }>;
};

export default function SelectCalendarVisibility({ onSelectHandler, ...props }: Props) {
    const { classes } = useStyles();
    const dispatch = useAppDispatch();

    const handleSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
        onSelectHandler({
            visibility: +event.target.value as CalendarEventVisibility,
        });
    };

    //console.log('Object.values(MyEnum)', Object.entries(CalendarEventVisibility).filter(([key, value]) => isNaN(+key)).map((key, value) => (key)))

    return (
        <TextField
            {...(props as TextFieldProps)}
            select
            className={classes.root}
            id={props.id || 'select_calendar_event_visiblity'}
            label={props.label || 'Event Visibility'}
            onChange={handleSelect}
        >
            {Object.entries(CalendarEventVisibility)
                .filter(([key, value]) => isNaN(+key))
                .map(([key, value]) => (
                    <MenuItem key={value} value={value}>
                        {key}
                    </MenuItem>
                ))}
        </TextField>
    );
}
